module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "投放渠道",
      "width": "40%",
      "visible": _vm.visible,
      "before-close": _vm.handleClose,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "formRef",
    attrs: {
      "model": _vm.formInfo,
      "label-width": "120px",
      "label-position": "right",
      "size": "small",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "渠道代码",
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "渠道代码",
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.formInfo.code),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "code", $$v)
      },
      expression: "formInfo.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "渠道名称",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "渠道名称",
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.title),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "title", $$v)
      },
      expression: "formInfo.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formInfo.isNew),
      expression: "!formInfo.isNew"
    }],
    attrs: {
      "label": "小程序码",
      "prop": "image"
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.formInfo.image
    }
  })])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-214ab91f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/activity/components/info.vue
// module id = 1601
// module chunks = 0